angular.module('unergie.main')
.factory('BubblesService', () => {
    const width = 600
    const height = 350
    const bubbleRadius = 30

    const force = d3.forceSimulation()
    .force('charge', d3.forceManyBody().strength(bubbleRadius))
    .force('collision', d3.forceCollide(bubbleRadius + 2).strength(1))



    function dragstarted(d) {
        force.restart()
        force.alpha(0.7)
        d.fx = d.x
        d.fy = d.y
    }

    function dragging(d) {
        d.fx = Math.min(width, Math.max(0, d3.event.x))
        d.fy = Math.min(height, Math.max(0, d3.event.y))
    }

    function dragended(d) {
        d.fx = null
        d.fy = null
        force.alphaTarget(0.1)
    }



    function BubblesService(selector) {
        const mapBubble = new Map()
        const svg = d3.select(selector).append('svg').attr('width', width).attr('height', height).style('font-size', `${bubbleRadius}px`)



        function add(picto) {
            const x = (width / 4) + (Math.random() * (width / 2))
            const y = (height / 4) + (Math.random() * (height / 2))
            const g = svg.append('g').attr('class', 'bubble-node').attr('transform', `translate(${x}, ${y})`)
            const bubble = {
                g,
                x,
                y,
            }

            g.data([bubble])
            g.append('circle').attr('r', bubbleRadius)
            g.append('text').attr('dy', '0.5em').text(picto)
            g.call(d3.drag().on('start', dragstarted).on('drag', dragging).on('end', dragended))

            mapBubble.set(picto, bubble)
            updateForce()
        }

        function remove(picto) {
            const bubble = mapBubble.get(picto)

            if (bubble) {
                bubble.g.remove()
            }

            mapBubble.delete(picto)
            updateForce()
        }

        function updateForce() {
            force.stop()

            const listBubble = Array.from(mapBubble.values())
            force.nodes(listBubble).on('tick', () => {
                listBubble.forEach((bubble) => {
                    bubble.g.attr('transform', `translate(${bubble.x}, ${bubble.y})`)
                })
            })
            .alpha(1)
            .restart()
        }

        function flush() {
            force.stop()
            mapBubble.clear()
            svg.selectAll('*').remove()
        }

        function getSize() {
            return mapBubble.size
        }



        flush()

        return {
            add,
            remove,
            flush,
            getSize,
        }
    }

    return BubblesService
})
